import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../hook/Translation';

export default function PageNotFound() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <Box>
            <Grid className='generalContainer' container spacing={4} mx={'auto'} mt={'50px'} mb={'50px'}>
                <Grid size={12} height={{md: '500px', xs: '300px'}}>
                    <Box justifyContent={'center'} alignItems={'center'} display={'flex'} height={1}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/404.svg`} alt='not found' height={1} className='fitCover' loading='lazy' />
                    </Box>
                </Grid>
                <Grid size={12}>
                    <Typography variant="h1" textAlign={'center'} color='text.secondary' fontFamily={'DanmarkURW'} fontWeight={'bold'}>Page Not Found</Typography>
                </Grid>
                <Grid size={12}>
                    <Box mx={'auto'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                        <Button onClick={() => navigate(-1)} variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 buttonTextSize defaultButton noShadow' sx={{ backgroundColor: 'text.secondary', color: 'text.primary' }}>Go Back</Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}